var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceDocxFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 210,
    viewBox: "0 0 201 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-3.2%",
    width: "107.2%",
    height: "106.5%",
    filterUnits: "objectBoundingBox",
    id: "h242pxh8ra"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#h242pxh8ra)",
    fill: "#F0EFEF",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h135.207l51.101 51.101V196a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 38.708,
    height: 38.626,
    rx: 4,
    transform: "translate(80.847 80.07)",
    fill: "#185ABD",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.522 105.54c.057.427.094.8.112 1.118h.065c.026-.302.076-.666.15-1.093.074-.427.146-.788.217-1.08l3.032-12.58h3.922l3.138 12.39c.157.613.287 1.39.392 2.338h.052c.044-.654.153-1.407.327-2.263l2.51-12.466h3.57l-4.394 18.022h-4.17l-2.994-11.94a26.132 26.132 0 0 1-.294-1.344 14.878 14.878 0 0 1-.202-1.206h-.053c-.035.293-.102.729-.202 1.306a32.12 32.12 0 0 1-.242 1.282l-2.81 11.902H92.41L87.98 91.904h3.633l2.733 12.606c.061.258.12.602.176 1.03l5.472-10.455",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.207 5 51.101 51.101h-47.101a4 4 0 0 1-4-4V5z",
    fill: "#6F95D1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceDocxFile);
export default __webpack_public_path__ + "static/media/compliance-docx-file.01fb73db.svg";
export { ForwardRef as ReactComponent };